export class ImpactAssessmentDetailListModel {
    assessmentDetails1: Array<ItemDetailList>;
    assessmentDetails2: Array<ItemDetailList>;
    actionRequired: Array<ItemDetailList>;
    assessmentActionReq: Array<ItemDetailList>;
    reviewDetails: Array<ItemDetailList>;
    implementationDetails: Array<ItemDetailList>;
    assessmentPubPro!: Array<ItemDetailList>;

    constructor() {
        this.assessmentDetails1 = [];
        this.assessmentDetails2 = [];
        this.actionRequired = [];
        this.assessmentActionReq = [];
        this.reviewDetails = [];
        this.implementationDetails = [];
    }
}

export class ItemDetailList {
    itemTitle: string;
    createdOn: Date;

    constructor() {
        this.itemTitle = '';
        this.createdOn = new Date();
    }
}
